// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1868":"8b5ec994","2858":"8655a311","3754":"f5f7b04d","4679":"c9986132","5468":"c0c603c1","7375":"3b42f087","7850":"6d178cd7","8688":"496d5990"}[chunkId] + ".chunk.css";
};